import faMessages from '../locales/fa_IR';
import FeaturesLocals from 'features/configs/l10n';

const FaLang = {
  messages: {
    ...faMessages,
    ...FeaturesLocals.fa
  },
  locale: 'en',
};
export default FaLang;
